// 'use client';
// import { useLocale } from 'next-intl';
// // import React from 'react';

// import config from '@/api/global';

// export default function getlocale() {
//   const locale = useLocale();
//   return locale;
// }

// =========

// utils/locale.js
// export const getLocale = () => {
//   if (typeof window === 'undefined') return 'en'; // default for server
//   const segments = window.location.pathname.split('/').filter(Boolean);
//   return segments[0] || 'en';
// };

// ============

// utils/locale.js
export const getLocale = (defaultLocale = 'en', supportedLocales = ['en', 'fa']) => {
  if (typeof window === 'undefined') return defaultLocale;

  const segments = window.location.pathname.split('/').filter(Boolean);
  const firstSegment = segments[0];

  if (supportedLocales.includes(firstSegment)) {
    return firstSegment;
  }

  return defaultLocale;
};
